import React from 'react';

const ManageBookingSection = ({children, ...rest}) => {
    return (
        <div
            className="CancelSection__section CancelSection__section--normal"
            {...rest}
        >
            {children}
        </div>
    );
};

export default ManageBookingSection;
